import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/mobile",
    name: "Mobile",
    component: () => import("../views/Home/Mobile.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login/Index.vue"),
  },
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home/Index.vue"),
    children: [
      {
        path: "/",
        name: "Main",
        component: () => import("../views/Home/Main.vue"),
      },
      {
        path: "/record",
        name: "Record",
        component: () => import("../views/Home/Record.vue"),
      },
      {
        path: "/detail/:id",
        name: "Detail",
        component: () => import("../views/Home/Detail.vue"),
      },
      {
        path: "/check/:id",
        name: "Check",
        component: () => import("../views/Home/Check.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
